// extracted by mini-css-extract-plugin
export default {"root":"vAiIzeD","menu":"PsQiBcB","menuCaptionSubtitle":"cA3Qmgv"};